import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";

import ApiService from "services/ApiService";
import AuthService from "services/AuthService";
import { ContextOne } from "contexts/ContextOne";
import { dateLocalDisplay } from "lib/Utils";
import OrganizationForm from "components/Organizations/OrganizationForm";
import Modal from "components/UI/Modal"
import { ToasterContext } from "contexts/ToasterContext";
import withAuth from "withAuth";

import "./Organizations.scss";

const Organizations = () => {
  const { state, dispatch } = useContext(ContextOne);
  const { AddToast } = useContext(ToasterContext);
  const { loggedIn, user } = state;

  const [organizations, setOrganizations] = useState(null);

  const [showOrganizationForm, setShowOrganizationForm] = useState(false);

  // Routing

  let navigate = useNavigate();

  const routeToOrganization = (uuid) => {
    let path = `/organizations/${uuid}`;
    navigate(path);
  };

  // Data Fetching

  const fetchOrganizations = async () => {
    const data = await ApiService.getOrganizations();
    setOrganizations(data);
  };

  const fetchData = async () => {
    dispatch({ type: "loading", val: true });

    await fetchOrganizations();

    dispatch({ type: "loading", val: false });
  };

  const handleOrganizationSubmit = async (organization) => {
    dispatch({ type: "loading", val: true });

    AuthService.fetch(`${process.env.REACT_APP_API_ENDPOINT}/organizations`, {
      method: "POST",
      body: JSON.stringify({
        name: organization.name,
        description: organization.description
      })
    })
    .then(
      async (result) => {
        await fetchOrganizations();
        AddToast("success", "Organization Added", null);
        return;
      },
      (error) => {
        AddToast("danger", null, error);
        return;
      }
    )
    .then(() => {
      dispatch({ type: "loading", val: false });
      setShowOrganizationForm(false);
    })
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOrganizationShowModal = (event) => {
    event.preventDefault();

    setShowOrganizationForm(true);
  };

  const handleOrganizationCloseModal = (_event) => {
    setShowOrganizationForm(false);
  };

  return (
    <>
      <div className="organizations-component text-center">
        <div className="organizations-header">
          <div className="title">
            <h1>Organizations</h1>
          </div>
        </div>

        <table className="table tbl-striped table-sm">
          <thead>
            <tr>
              <th>Name</th>
              <th>Status</th>
              <th>Created Date</th>
              <th>
                { loggedIn && user.is_admin &&
                  <div className="icon-button" onClick={handleOrganizationShowModal}>
                    <FontAwesomeIcon icon={faPlusCircle} />
                  </div>
                }
              </th>
            </tr>
          </thead>

          <tbody>
            {organizations &&
              organizations.map((o) => (
                <tr key={o.uuid} onClick={() => routeToOrganization(o.uuid)}>
                  <td>{o.name}</td>
                  <td>{o.status}</td>
                  <td>{dateLocalDisplay(o.created_at)}</td>
                  <td></td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      <Modal show={showOrganizationForm} modalClosed={handleOrganizationCloseModal}>
        <h4 className="text-center">Create Organization</h4>
        <hr/>

        {showOrganizationForm && (
          <OrganizationForm
            cancelForm={handleOrganizationCloseModal}
            handleSubmit={handleOrganizationSubmit}
          />
        )}
      </Modal>
    </>
  );
};

export default withAuth(Organizations);
